import { render, staticRenderFns } from "./gj-dialog.vue?vue&type=template&id=504660a7&scoped=true&"
import script from "./gj-dialog.vue?vue&type=script&lang=js&"
export * from "./gj-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504660a7",
  null
  
)

export default component.exports